//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import contact from '~/graphql/mutations/contact.gql';
import page from '~/plugins/mixins/page';

export default {
  auth: false,
  mixins: [page],
  data: () => ({
    formName: 'contact',
    openedDropdown: 0,
    location: {
      lat: 51.65559,
      lng: 5.6217944,
    },
    mapsImage: require('~/assets/img/location-map.png'),
    captcha: '',
  }),
  methods: {
    async sendContactRequest(data) {
      if (!this.captcha) {
        this.$toast.error('CAPTCHA is verplicht.');
        return;
      }
      let failed = false;
      try {
        await this.$apollo.mutate({
          mutation: contact,
          variables: {
            ...data,
            captcha: this.captcha,
          },
        });
      } catch (e) {
        failed = true;

        let message = e.message || 'Er is een onbekende fout opgetreden.';

        const graphQLError = e.graphQLErrors?.[0];
        const validationErrors = graphQLError?.extensions?.validation;

        if (validationErrors) {
          const firstField = Object.keys(validationErrors)[0];
          if (firstField && validationErrors[firstField][0]) {
            message = validationErrors[firstField][0];
          }
        }

        this.$toast.error(message);
      }
      if (!failed) {
        this.$toast.success('Bedankt voor uw vraag, deze zal zo spoedig mogelijk beantwoord worden.');
        this.$formulate.reset(this.formName);
      }
    },
  },
};

